import styled from 'styled-components';

const SectionHomePage = styled.section``;

export default SectionHomePage;
